import { useAppDispatch } from '@/hooks'
import { useState } from 'react'
import { submitQuestions } from '@/actions/manualPlans'
import { BooleanInput, FlowStep, Question } from 'app-components'
import {
  CardActionButton,
  CardActions,
  CardNavigation,
  Grid,
} from '@/components'

type Props = {
  onOptionSelect?: () => void
}

function useViewModel(props: Props) {
  const dispatch = useAppDispatch()
  const [weekdaysDiffer, setWeekdaysDiffer] = useState<boolean | null>()
  const [monthsDiffer, setMonthsDiffer] = useState<boolean | null>()

  const onWeekdaysChange = (differ: boolean | null) => {
    setWeekdaysDiffer(differ)
  }
  const onMonthsChange = (differ: boolean | null) => {
    setMonthsDiffer(differ)
  }

  const onSubmit = () => {
    dispatch(submitQuestions(weekdaysDiffer, monthsDiffer))
    props.onOptionSelect?.()
  }

  return {
    onWeekdaysChange,
    onMonthsChange,
    onSubmit,
  }
}

export default function SelectManualUtilityPlanOptionsFlowStep(props: Props) {
  const { onWeekdaysChange, onMonthsChange, onSubmit } = useViewModel(props)

  return (
    <FlowStep id="select-manual-utility-plan-options-flow">
      <FlowStep.Content>
        <CardNavigation id="select-manual-utility-plan-options-card-navigation" />
        <Grid flow="row" gap="32px">
          <Question
            title="Add utility plan manually"
            subtitle="Are your rates on weekdays different than on weekends?"
          >
            <BooleanInput onChange={onWeekdaysChange} />
          </Question>
          <Question subtitle="Do you have different rates for different months?">
            <BooleanInput onChange={onMonthsChange} />
          </Question>
        </Grid>
      </FlowStep.Content>

      <FlowStep.Actions>
        <CardActions>
          <CardActionButton
            type="primary"
            onClick={onSubmit}
            id="select-manual-utility-plan-options-card-select-button"
          >
            Next
          </CardActionButton>
        </CardActions>
      </FlowStep.Actions>
    </FlowStep>
  )
}
